export default __webpack_public_path__ + "static/media/indigo.0319d80c.png";